import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "grid-content" }
const _hoisted_3 = { class: "grid-content" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = { class: "data-show other" }
const _hoisted_6 = { class: "member_data" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = { class: "compere" }
const _hoisted_9 = { class: "number" }
const _hoisted_10 = { class: "compere" }
const _hoisted_11 = {
  class: "right",
  id: "member_data",
  ref: "lineChart",
  style: { width: '1050px', height: '300px' }
}
const _hoisted_12 = { class: "box" }
const _hoisted_13 = { class: "data-show" }
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "box" }
const _hoisted_16 = { class: "data-show other" }
const _hoisted_17 = { class: "top" }
const _hoisted_18 = { class: "show" }
const _hoisted_19 = { class: "show" }
const _hoisted_20 = { class: "show" }

import { getCurrentInstance, ref, onMounted, reactive } from 'vue'
import { useStore } from '@/store/index'
import * as echarts from 'echarts'
import { Top, Bottom } from '@element-plus/icons-vue'
import { getDelayTime, dateFormat } from '@/utils/index'

export default /*@__PURE__*/_defineComponent({
  __name: 'Member',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const hasShop = store.state.user.userInfo
const today = new Date()
const current = dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`);
const filters = reactive({
    start_time: getDelayTime(current, -15, 'date'), //开始日期
    end_time: dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`), //结束日期
})
const state = reactive({
    member_count: [],//会员数
    member_count_total: 0,//会员总数
    member_buy_count: 0,//会员购买数
    member_count_grow: 0,//较上一期会员数增长量
    member_buy_count_grow: 0,//较上一期会员购买数增长量
    index_dialog_count: 0,
    icon_dialog_count: 0,
    center_dialog_count: 0,
    detail_dialog_count: 0,
    index_dialog_rate: '',//首页弹窗占比
    icon_dialog_rate: '',//icon弹窗占比
    center_dialog_rate: '',//个人中心弹窗占比
    detail_dialog_rate: '',//详情页弹窗占比
    other_brithday: 0,
    take_count: 0,
    second_take_count: 0,
    my_birthday: 0,
    pv_count: 0,
    uv_count: 0,
    back_pay: [],//退一赔一
    before_pay: [],//先行赔付
    sup_use: [],//专项劵
    count_down: [],//会员秒杀
    ele_cart: [],//电子贺卡
    topspeed: [],//极速达
    insurance: [],//生活福利
    brithday: [],//生日管家
    date: [],//返回日期
    table_data: []//会员来源排行

})
const getList = () => {
    //@ts-ignore
    proxy.$http.get('/admin/user/get_member_info', filters).then(res => {
        const { code, data, msg } = res
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        Object.assign(state, data)
        initLineEcharts()
        initBarEcharts()
        initLineMoreEcharts()
    })
}
getList()
const onDay = (type) => {
    let current = dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 1}`);
    let week = getDelayTime(current, -7, 'date')
    let month = getDelayTime(current, -30, 'date')
    switch (type) {
        case 2:
            //@ts-ignore
            filters.start_time = week;
            //@ts-ignore
            filters.end_time = current;
            break;
        case 3:
            //@ts-ignore
            filters.start_time = month;
            //@ts-ignore
            filters.end_time = current;
        default:
            break;
    }
    getList()
}
const search = () => {
    if (filters.start_time && filters.end_time) {
        if (filters.end_time >= filters.start_time) {
            getList()
        } else {
            proxy.$message({ type: 'error', message: '结束时间不能早于开始时间' })
        }
    }else{
        proxy.$message({ type: 'error', message: '日期不能为空' })
    }
}
//@ts-ignore
const disabledStartDate = (date) => { // 返回开始不可用日期
    //所选时间小于等于当前日期
    var start = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    return start > current
}
//@ts-ignore
const disabledEndDate = (date) => { // 返回结束不可用日期
    //@ts-ignore
    var start = new Date(filters.start_time).getTime()
    //所选时间小于等于当前日期
    //@ts-ignore
    var end = date.getTime() + 24 * 60 * 60 * 1000
    var current = Date.now()
    //所选时间小于等于当前日期或小于开始日期
    return end > current || end < start
}
const initLineEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('member_data')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: '会员数统计表'
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['会员数']
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: state.date
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: '会员数',
                type: 'line',

                data: state.member_count
            },
        ]
    };
    option && myChart.setOption(option);
}
const initBarEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('member_dialog')!);
    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            top: '5%',
            left: 'center'
        },
        series: [
            {
                name: '弹窗比例',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    label: {
                        show: false,
                        fontSize: 40,
                        fontWeight: 'bold'
                    }
                },
                labelLine: {
                    show: false
                },
                data: [
                    { value: state.index_dialog_count, name: '首页弹窗占比' + state.index_dialog_rate },
                    { value: state.icon_dialog_count, name: 'icon弹窗占比' + state.icon_dialog_rate },
                    { value: state.center_dialog_count, name: '个人中心弹窗占比' + state.center_dialog_rate },
                    { value: state.detail_dialog_count, name: '详情页弹窗占比' + state.detail_dialog_rate }
                ]
            }
        ]
    };
    option && myChart.setOption(option);
}
const initLineMoreEcharts = () => {
    //  基于准备好的dom，初始化echarts实例
    let myChart = echarts.init(document.getElementById('member_user')!);
    // 指定图表的配置项和数据
    let option = {
        title: {
            text: '会员八项权益统计表'
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['退一赔一', '先行赔付', '专项劵', '会员秒杀', '电子贺卡', '极速达', '生活福利', '生日管家']
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: state.date
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: '退一赔一',
                type: 'line',

                data: state.back_pay
            },
            {
                name: '先行赔付',
                type: 'line',

                data: state.before_pay
            },
            {
                name: '专项劵',
                type: 'line',

                data: state.sup_use
            },
            {
                name: '会员秒杀',
                type: 'line',

                data: state.count_down
            },
            {
                name: '电子贺卡',
                type: 'line',

                data: state.count_down
            },
            {
                name: '极速达',
                type: 'line',

                data: state.topspeed
            },
            {
                name: '生活福利',
                type: 'line',

                data: state.insurance
            },
            {
                name: '生日管家',
                type: 'line',

                data: state.brithday
            },
        ]
    };
    option && myChart.setOption(option);
}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, {
      offset: 0,
      style: {"background-color":"#fff"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { style: {"margin-top":"10px","padding":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text" }, "选择日期：", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.start_time,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.start_time) = $event)),
                    "disabled-date": disabledStartDate,
                    placeholder: "开始日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"]),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text" }, " - ", -1)),
                  _createVNode(_component_el_date_picker, {
                    class: "filter-item",
                    type: "date",
                    modelValue: filters.end_time,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.end_time) = $event)),
                    "disabled-date": disabledEndDate,
                    placeholder: "结束日期",
                    "value-format": "YYYY-MM-DD",
                    style: {"width":"170px"},
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onDay(2)))
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("近七日")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (onDay(3)))
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("近30天")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    class: "filter-btn",
                    type: "primary",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (search()))
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "member" }, [
        _createElementVNode("div", { class: "tag" }),
        _createElementVNode("span", null, "会员数据")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_row, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text" }, "会员数:", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(state.member_count_total) + "人", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[11] || (_cache[11] = _createTextVNode("较上一周期")),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (state.member_count_grow >= 0)
                          ? (_openBlock(), _createBlock(_unref(Top), { key: 0 }))
                          : _createCommentVNode("", true),
                        (state.member_count_grow < 0)
                          ? (_openBlock(), _createBlock(_unref(Bottom), { key: 1 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(Math.abs(state.member_count_grow)) + "人", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text" }, "会员购买数:", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(state.member_buy_count) + "人", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[13] || (_cache[13] = _createTextVNode("较上一周期")),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        (state.member_buy_count_grow >= 0)
                          ? (_openBlock(), _createBlock(_unref(Top), { key: 0 }))
                          : _createCommentVNode("", true),
                        (state.member_buy_count_grow < 0)
                          ? (_openBlock(), _createBlock(_unref(Bottom), { key: 1 }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(Math.abs(state.member_buy_count_grow)) + "人", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_11, null, 512)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "member" }, [
        _createElementVNode("div", { class: "tag" }),
        _createElementVNode("span", null, "会员来源")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "title" }, "会员来源排行", -1)),
          _createVNode(_component_el_table, {
            data: state.table_data,
            stripe: "",
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "rank",
                label: "排行"
              }),
              _createVNode(_component_el_table_column, {
                prop: "location",
                label: "位置"
              }),
              _createVNode(_component_el_table_column, {
                prop: "category_count",
                label: "会员数"
              }),
              _createVNode(_component_el_table_column, {
                prop: "category_rate",
                label: "占比"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "right",
          id: "member_dialog",
          style: { width: '400px', height: '300px' }
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "member" }, [
        _createElementVNode("div", { class: "tag" }),
        _createElementVNode("span", null, "其他数据")
      ], -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  span: 24,
                  class: "show_data"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("填写生日用户")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("本人生日")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.my_birthday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("他人生日")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.other_brithday), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { class: "show_data" }, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("生活福利")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("领取人数")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.take_count), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("二次转化人数")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.second_take_count), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { class: "show_data" }, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("会员页面")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("PV")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.pv_count), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { class: "show_text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("UV")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.uv_count), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _cache[27] || (_cache[27] = _createElementVNode("div", {
          class: "right",
          id: "member_user",
          style: { width: '1050px', height: '400px' }
        }, null, -1))
      ])
    ])
  ]))
}
}

})